var _defs, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelType3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 72,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-b74b1c27-da4e-42d8-b3fe-937df4d762b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,72v0v-72v0h72v0v72v0z"
  })))), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Gruppe 3298"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Rechteck 2511")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-b74b1c27-da4e-42d8-b3fe-937df4d762b0)"
  }, /*#__PURE__*/React.createElement("title", null, "Rechteck 2510"), /*#__PURE__*/React.createElement("path", {
    d: "M19,68c-1.65685,0 -3,-1.34315 -3,-3v-54c0,-1.65685 1.34315,-3 3,-3h34c1.65685,0 3,1.34315 3,3v54c0,1.65685 -1.34315,3 -3,3z",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-b74b1c27-da4e-42d8-b3fe-937df4d762b0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5834"), /*#__PURE__*/React.createElement("path", {
    d: "M20,6v0v-0.5c0,-0.828 0.672,-1.5 1.5,-1.5h9c0.828,0 1.5,0.672 1.5,1.5v0.5v0v2v0h-12.063v0z",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-b74b1c27-da4e-42d8-b3fe-937df4d762b0)"
  }, /*#__PURE__*/React.createElement("title", null, "Linie 542"), /*#__PURE__*/React.createElement("path", {
    d: "M40.4534,28h17.547",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-b74b1c27-da4e-42d8-b3fe-937df4d762b0)"
  }, /*#__PURE__*/React.createElement("title", null, "Linie 543"), /*#__PURE__*/React.createElement("path", {
    d: "M14,28h17.746",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-b74b1c27-da4e-42d8-b3fe-937df4d762b0)"
  }, /*#__PURE__*/React.createElement("title", null, "Linie 544"), /*#__PURE__*/React.createElement("path", {
    d: "M46.5154,48h11.485",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-b74b1c27-da4e-42d8-b3fe-937df4d762b0)"
  }, /*#__PURE__*/React.createElement("title", null, "Linie 545"), /*#__PURE__*/React.createElement("path", {
    d: "M14,48h11",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-b74b1c27-da4e-42d8-b3fe-937df4d762b0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5835"), /*#__PURE__*/React.createElement("path", {
    d: "M25.986,40.227c-0.708,1.556 -1.068,3.304 -0.97,5.147c0.297,5.609 4.972,10.202 10.586,10.399c6.256,0.221 11.398,-4.786 11.398,-10.993c0,-1.628 -0.355,-3.171 -0.99,-4.561c-0.024,-0.053 -8.835,-19.428 -8.835,-19.428c-0.46,-0.755 -1.553,-0.764 -2.025,-0.016c0,0 -9.138,19.394 -9.164,19.452z",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-b74b1c27-da4e-42d8-b3fe-937df4d762b0)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5836"), /*#__PURE__*/React.createElement("path", {
    d: "M29.846,44.533c0.147,2.525 1.879,4.941 4.351,5.689",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelType3);
export default __webpack_public_path__ + "static/media/fuel-type-3.a46dc4f902577051095b2c9fb4f984d6.svg";
export { ForwardRef as ReactComponent };